import React from "react";
import SvgIcon from "@material-ui/core/SvgIcon";

// A downward pointing arrow in a hand drawn style
const DownArrowDoodle = props => (
  <SvgIcon viewBox="0 0 362.044 362.044" {...props}>
    <path d="M168.41742651 358.37151807c2.448 4.896 10.404 4.896 12.852 0 20.808-37.944 39.78-76.5 50.796-118.116 1.224-6.12-5.508-12.24-11.016-8.568-12.24 8.568-22.644 18.972-31.824 31.212 2.448-85.68 14.076-174.42-6.12-258.876-1.224-6.12-11.627-4.896-11.015 1.225 11.015 87.516 2.447 174.42 1.224 261.936-10.404-9.18-20.808-18.36-30.6-27.54-4.284-4.284-13.465-1.836-12.853 5.508 4.897 40.391 18.361 78.335 38.556 113.219zm6.732-72.828c3.672 5.508 14.076 4.284 14.076-4.284v-1.224c7.344-7.344 14.076-14.688 22.032-22.032-9.792 28.152-22.032 54.468-36.107 80.784-12.24-23.868-21.42-48.348-26.316-74.664 6.732 6.12 14.076 12.24 20.809 18.972 1.222 2.448 3.671 3.06 5.506 2.448z" />
  </SvgIcon>
);

export default DownArrowDoodle;
